import { __decorate, __param } from 'tslib';
import { InjectionToken, ElementRef, Inject, Input, HostBinding, Directive, NgModule } from '@angular/core';
import { TuiDestroyService, TuiFocusVisibleService, typedFromEvent, stopPropagation, tuiDefaultProp } from '@taiga-ui/cdk';
import { TuiHintService } from '@taiga-ui/core/services';
import { timer, merge, Observable } from 'rxjs';
import { filter, switchMapTo, mapTo, takeUntil, take, startWith, distinctUntilChanged } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core/services';
import * as ɵngcc2 from 'rxjs';
const DELAY = 1000;
const TUI_DESCRIBED_BY_SHOW = new InjectionToken('Accessible tooltip visibility stream');
const TUI_DESCRIBED_BY_PROVIDERS = [
    TuiDestroyService,
    TuiFocusVisibleService,
    {
        provide: TUI_DESCRIBED_BY_SHOW,
        deps: [TuiFocusVisibleService, ElementRef],
        useFactory: describedByFactory,
    },
];
function describedByFactory(focusVisible$, { nativeElement }) {
    return focusVisible$
        .pipe(filter(Boolean), switchMapTo(timer(DELAY).pipe(mapTo(true), takeUntil(merge(typedFromEvent(nativeElement, 'keydown'), typedFromEvent(nativeElement, 'blur'))))), switchMapTo(merge(typedFromEvent(nativeElement, 'keydown').pipe(filter(({ key }) => key === 'Escape'), take(1), stopPropagation(), mapTo(false), startWith(true)), typedFromEvent(nativeElement, 'blur').pipe(mapTo(false)))))
        .pipe(distinctUntilChanged());
}

const DESCRIBED_BY = '_described-by';
/**
 * A directive linking focusable elements and hints for accessibility
 */
let TuiDescribedByDirective = class TuiDescribedByDirective {
    constructor(hintService, visibility$) {
        this.tuiDescribedBy = '';
        visibility$.subscribe(visible => {
            if (!this.tuiDescribedBy) {
                return;
            }
            if (visible) {
                hintService.showHintForId(this.tuiDescribedBy);
            }
            else {
                hintService.hideHintForId(this.tuiDescribedBy);
            }
        });
    }
    get computedDescribedBy() {
        return this.tuiDescribedBy ? this.tuiDescribedBy + DESCRIBED_BY : null;
    }
};
TuiDescribedByDirective.ɵfac = function TuiDescribedByDirective_Factory(t) { return new (t || TuiDescribedByDirective)(ɵngcc0.ɵɵdirectiveInject(TuiHintService), ɵngcc0.ɵɵdirectiveInject(TUI_DESCRIBED_BY_SHOW)); };
TuiDescribedByDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiDescribedByDirective, selectors: [["", "tuiDescribedBy", "", 5, "ng-container"]], hostVars: 1, hostBindings: function TuiDescribedByDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.computedDescribedBy);
    } }, inputs: { tuiDescribedBy: "tuiDescribedBy" }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_DESCRIBED_BY_PROVIDERS)] });
TuiDescribedByDirective.ctorParameters = () => [
    { type: TuiHintService, decorators: [{ type: Inject, args: [TuiHintService,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_DESCRIBED_BY_SHOW,] }] }
];
__decorate([
    Input(),
    tuiDefaultProp()
], TuiDescribedByDirective.prototype, "tuiDescribedBy", void 0);
__decorate([
    HostBinding('attr.aria-describedby')
], TuiDescribedByDirective.prototype, "computedDescribedBy", null);
TuiDescribedByDirective = __decorate([ __param(0, Inject(TuiHintService)),
    __param(1, Inject(TUI_DESCRIBED_BY_SHOW))
], TuiDescribedByDirective);

let TuiDescribedByModule = class TuiDescribedByModule {
};
TuiDescribedByModule.ɵfac = function TuiDescribedByModule_Factory(t) { return new (t || TuiDescribedByModule)(); };
TuiDescribedByModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDescribedByModule });
TuiDescribedByModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDescribedByDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiDescribedBy]:not(ng-container)',
                providers: TUI_DESCRIBED_BY_PROVIDERS
            }]
    }], function () { return [{ type: ɵngcc1.TuiHintService, decorators: [{
                type: Inject,
                args: [TuiHintService]
            }] }, { type: ɵngcc2.Observable, decorators: [{
                type: Inject,
                args: [TUI_DESCRIBED_BY_SHOW]
            }] }]; }, { tuiDescribedBy: [{
            type: Input
        }], computedDescribedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDescribedByModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiDescribedByDirective],
                exports: [TuiDescribedByDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDescribedByModule, { declarations: [TuiDescribedByDirective], exports: [TuiDescribedByDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { DESCRIBED_BY, TUI_DESCRIBED_BY_PROVIDERS, TUI_DESCRIBED_BY_SHOW, TuiDescribedByDirective, TuiDescribedByModule, describedByFactory };

